import {
  LibraryContentObject,
  SubjectAlignment,
  LibraryGoal,
  LibraryStrategy,
  LibraryPresentLevel,
  LibraryPresentLevelStudentSummary,
  LibraryResource,
  LibraryImpactOfDisability,
} from '@/library/library_types'
import { getSubjectLabelByContentType } from '@/contentprofile/no_sel_composable'
import { CONTENT_TYPES } from '@/util/access_visibility'

export function filterGoalsBySubject(goals: LibraryContentObject[], subject: string): LibraryContentObject[] {
  const subjectLabel = getSubjectLabelByContentType(CONTENT_TYPES.GOAL, subject)
  return goals?.filter((goal) =>
    (goal.content_body as LibraryGoal).subject_alignments?.some(
      (alignment: SubjectAlignment) => getSubjectLabelByContentType(CONTENT_TYPES.GOAL, alignment.subject) === subjectLabel
    )
  )
}

export function filterStrategiesBySubject(strategies: LibraryContentObject[], subject: string): LibraryContentObject[] {
  const subjectLabel = getSubjectLabelByContentType(CONTENT_TYPES.STRATEGY, subject)
  return strategies.filter((strategy) =>
    (strategy.content_body as LibraryStrategy).source_strategy.tags.some(
      (tag) => getSubjectLabelByContentType(CONTENT_TYPES.STRATEGY, tag) === subjectLabel
    )
  )
}

export function filterResourcesBySubject(resources: LibraryContentObject[], subject: string): LibraryContentObject[] {
  const subjectLabel = getSubjectLabelByContentType(CONTENT_TYPES.RESOURCE, subject)
  return resources.filter((resource) =>
    (resource.content_body as LibraryResource).subjects.some(
      (singleSubject) => getSubjectLabelByContentType(CONTENT_TYPES.RESOURCE, singleSubject) === subjectLabel
    )
  )
}

export function filterPresentLevelsBySubject(presentlevels: LibraryContentObject[], subject: string): LibraryContentObject[] {
  return presentlevels.filter((presentlevel) => {
    // Handle old Present Levels (with selected_subjects array)
    if (presentlevel.content_type === CONTENT_TYPES.PRESENTLEVEL) {
      const subjectLabel = getSubjectLabelByContentType(CONTENT_TYPES.PRESENTLEVEL, subject)
      return (presentlevel.content_body as LibraryPresentLevel).selected_subjects?.some(
        (singleSubject) => getSubjectLabelByContentType(CONTENT_TYPES.PRESENTLEVEL, singleSubject) === subjectLabel
      )
    }
    // Handle new v2.0 Present Levels Student Summaries (with subject_label string)
    if (presentlevel.content_type === CONTENT_TYPES.PRESENTLEVEL_STUDENT_SUMMARY) {
      const subjectLabel = getSubjectLabelByContentType(CONTENT_TYPES.PRESENTLEVEL_STUDENT_SUMMARY, subject)
      const summarySubject = (presentlevel.content_body as LibraryPresentLevelStudentSummary).subject_label
      return getSubjectLabelByContentType(CONTENT_TYPES.PRESENTLEVEL_STUDENT_SUMMARY, summarySubject) === subjectLabel
    }
    return false
  })
}

export function filterImpactOfDisabilitiesBySubject(impactOfDisabilities: LibraryContentObject[], subject: string): LibraryContentObject[] {
  const subjectLabel = getSubjectLabelByContentType(CONTENT_TYPES.IMPACT_OF_DISABILITY, subject)
  return impactOfDisabilities.filter((iod) =>
    (iod.content_body as LibraryImpactOfDisability).subjects?.some(
      (singleSubject) => getSubjectLabelByContentType(CONTENT_TYPES.IMPACT_OF_DISABILITY, singleSubject) === subjectLabel
    )
  )
}